import React, { useState } from "react";
import { CicdFaqs } from "../../../components/faqData.js";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const CiCdPipelines = () => {
  const [actIndex, setActIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActIndex(index === actIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Boost your software delivery with expert CI/CD Development Services. Streamline deployment, enhance performance, and scale faster with Ayanshtech Solutions."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="CI/CD Development Services | Web Solutions & DevOps Expertise | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/cicd-pipelines"
        />
        <meta
          property="og:description"
          content="Boost your software delivery with expert CI/CD Development Services. Streamline deployment, enhance performance, and scale faster with Ayanshtech Solutions."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="CI/CD Development Services | Web Solutions & DevOps Expertise | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Boost your software delivery with expert CI/CD Development Services. Streamline deployment, enhance performance, and scale faster with Ayanshtech Solutions."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="https://ayanshtechnology.com/cicd-pipelines"
        />
        <title>
          CI/CD Development Services | Web Solutions & DevOps Expertise |
          Ayanshtech Solutions
        </title>
      </Helmet>
      <div className="flex flex-col items-center justify-center p-6 gradient-background">
        <div className=" w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16 p-4">
            <div className="lg:w-3/4 lg:text-left mt-10">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                CI/CD Development Services for Seamless Software Delivery
              </h1>

              <p className="sm:text-base md:text-lg lg:text-lg mb-3">
                Accelerate your software development with Ayanshtech’s CI/CD
                Development Services designed for seamless software delivery. We
                help businesses automate their build, test, and deployment
                processes, ensuring faster, error-free, and more reliable
                releases. Our Continuous Integration and Continuous Delivery
                (CI/CD) solutions empower your team to deliver updates with
                confidence — improving collaboration, reducing manual work, and
                shortening release cycles.
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                At Ayanshtech, we design and implement end-to-end CI/CD
                pipelines using industry-leading tools like Jenkins, GitLab CI,
                and CircleCI. From automated testing to production deployment,
                our experts create pipelines tailored to your workflow for
                maximum efficiency and stability. Whether you’re looking to
                integrate automated testing, optimize your DevOps strategy, or
                build a scalable deployment process, we ensure your applications
                are always production-ready with faster, secure, and continuous
                delivery.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-6 lg:mb-0">
              <img
                src="\assets\images\devops\cicdImg1.svg"
                alt="CI/CD Development Services"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10 p-4">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of CI/CD Pipeline Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            CI/CD pipelines are essential for automating your development and
            deployment workflows. They enable faster delivery, better code
            quality, and improved collaboration. Our CI/CD pipeline solutions
            offer a wide range of features that streamline the entire
            development process.
          </p>
        </div>

        <div className=" p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Automated Testing</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Continuous Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Continuous Deployment</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Version Control Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Automated Build</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Monitoring and Alerts</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Scalable Pipelines</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Code Quality Analysis</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Deployment Automation</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Rollback Mechanisms</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Cloud Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 -h-10"
              />
              <p className="text-lg">Docker & Kubernetes Support</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Our CI/CD Pipeline Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Empower your development workflow with CI/CD pipelines, automating
            testing, deployment, and continuous delivery for improved efficiency
            and reliability.
          </p>
        </div>

        <div className=" ">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\devops\cicdImg2.jpg"
                alt="Laptop with graph"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon13.png"
                  alt="icon"
                  className="w-10 -h-10"
                />
                <div>
                  <p className="text-lg">
                    Implement automated testing to ensure high-quality, bug-free
                    applications at every stage of development.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon14.png"
                  alt="icon"
                  className="w-10 -h-10"
                />
                <div>
                  <p className="text-lg">
                    Automate deployments to reduce manual intervention,
                    enhancing release cycles and accelerating time-to-market.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon15.png"
                  alt="icon"
                  className="w-10 -h-10"
                />
                <div>
                  <p className="text-lg">
                    Integrate with version control systems for seamless code
                    merging, branching, and continuous delivery.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon16.png"
                  alt="icon"
                  className="w-10 -h-10"
                />
                <div>
                  <p className="text-lg">
                    Leverage containerization and orchestration tools like
                    Docker and Kubernetes for scalable and reliable deployments.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" rounded-3xl">
          <div className="text-center mb-5 mt-5">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              CI/CD Solutions We Deliver
            </h2>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Item 1 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Automated Testing</h3>
                <p className="text-lg">
                  Integrate automated testing into your CI/CD pipeline to ensure
                  bug-free and high-quality applications at each development
                  stage.
                </p>
              </div>

              {/* Item 2 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Automated Deployments</h3>
                <p className="text-lg">
                  Automate your deployment processes to reduce manual
                  intervention, enhancing consistency and accelerating release
                  cycles.
                </p>
              </div>

              {/* Item 3 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">
                  Version Control Integration
                </h3>
                <p className="text-lg">
                  Integrate your CI/CD pipeline with version control systems to
                  streamline code merging, branching, and delivery.
                </p>
              </div>

              {/* Item 4 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Continuous Delivery</h3>
                <p className="text-lg">
                  Ensure seamless and uninterrupted deployment by automating the
                  delivery of new features and fixes.
                </p>
              </div>

              {/* Item 5 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Containerization</h3>
                <p className="text-lg">
                  Utilize containerization technologies like Docker to create
                  consistent and scalable development environments across
                  different stages of deployment.
                </p>
              </div>

              {/* Item 6 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">
                  Orchestration with Kubernetes
                </h3>
                <p className="text-lg">
                  Integrate Kubernetes for seamless orchestration, ensuring
                  scalability, high availability, and consistency for your
                  applications.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 sm:p-8 md:p-12 lg:p-16 w-full rounded-3xl">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Expert CI/CD Consulting and Support Solutions
            </h2>
          </div>

          <div className="mb-8">
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              At Ayanshtech, we provide professional CI/CD consulting and
              support services to help businesses streamline their development,
              testing, and deployment processes. Our team of experienced experts
              ensures your development lifecycle is efficient and automated for
              continuous delivery.
            </p>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Our key offerings include:
            </p>
            <ul className="list-disc pl-8 sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto">
              <li>CI/CD pipeline setup and optimization</li>
              <li>Automated testing and quality assurance integration</li>
              <li>Version control and branch management strategies</li>
              <li>
                Scalable deployment automation using Docker and Kubernetes
              </li>
              <li>Continuous monitoring and real-time feedback solutions</li>
            </ul>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Ayanshtech’s CI/CD specialists bring deep expertise in modern
              DevOps tools and best practices. We provide actionable insights
              and strategies to help you accelerate software delivery while
              ensuring the highest standards of reliability and security.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover: hover:text-blue-600 hover:border hover:border-blue-600 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300"
            >
              Schedule a Free Consultation Today!
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto p-6  w-full ">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {CicdFaqs.map((faq, index) => (
            <div key={index} className="border-b ">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  actIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {actIndex === index ? "-" : "+"}
                </span>
              </button>
              {actIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          {" "}
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default CiCdPipelines;
